import { render, staticRenderFns } from "./ClaimSalesIndex.vue?vue&type=template&id=0becfa7f&"
import script from "./ClaimSalesIndex.vue?vue&type=script&lang=js&"
export * from "./ClaimSalesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports